
import PropTypes from 'prop-types';
import React from 'react';
import NativeModal from 'react-modal';
import { connect } from 'react-redux';

import { removeOrdersByCids as removeOrdersByCidsAct } from '@xanadu/ui-shared/modules/portfolio/unsubmittedOrders/actions';
import { Order as OfferRecord } from '@xanadu/ui-shared/modules/portfolio/unsubmittedOrders/reducer';
import OrderPadWrapper from '@xanadu/ui-shared/components/betslip/FuturesBetslip/OrderPadWrapper';

import styles from './OrderPadModal.module.scss';

NativeModal.setAppElement(document.getElementById('root'));

const OrderPadModal = ({ offer, removeOffers, useContracts = false }) => {
  const handleClose = () => {
    if (offer) {
      removeOffers([offer.cid]);
    }
  };

  if (!offer) {
    return null;
  }

  return (
    <NativeModal
      isOpen
      className={styles.modal}
      overlayClassName="mb-modal__overlay"
      shouldCloseOnOverlayClick
      onRequestClose={handleClose}
    >
      {offer && <OrderPadWrapper offer={offer} useContracts={useContracts} />}
    </NativeModal>
  );
};

OrderPadModal.propTypes = {
  offer: PropTypes.instanceOf(OfferRecord),
  removeOffers: PropTypes.func.isRequired,
  useContracts: PropTypes.bool,
};

function mapStateToProps(state) {
  const unsubmittedOrders = state.getIn(['portfolio', 'unsubmittedOrders']);

  return {
    offer: unsubmittedOrders.first() || null,
  };
}

const mapDispatchToProps = {
  removeOffers: removeOrdersByCidsAct,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderPadModal);
